<bzg-modal-header>
    <div class="bmc-package-import__header">
        <span>{{ 'DEPLOYMENT.CONFIRM_TITLE' | translate }}</span>
        <bzg-button-icon icon="icon-close" (click)="close()"></bzg-button-icon>
    </div>
</bzg-modal-header>
<bzg-modal-content>
    <div *ngIf="data.objList && data.objList.length" class="bmc-package-import__body-container bz-space--stack-m">
        <bzg-icon [nameIcon]="'icon-warning'" [color]="'warning'" class="bz-space--inline-m"></bzg-icon>
        <div>
            {{ 'DEPLOYMENT.IMPORT_MODAL_TEXT' | translate }}
        </div>
    </div>
    <div *ngIf="data.objList && data.objList.length" class="bmc-package-import__object-list bz-space--stack-m">
        <bzg-icon [nameIcon]="!objListOpen?'icon-arrow-down-table':'icon-arrow-up-table'"
            class="bz-space--inline-m bmc-package-import__object-list-icon" (click)="objListOpen=!objListOpen">
        </bzg-icon>
        <strong class="bmc-package-import__object-list-title">{{ 'DEPLOYMENT.OBJECT_LIST' | translate }}</strong>
        <div class="bmc-package-import__line bz-color-border--neutral-300"></div>
    </div>
    <div class="bmc-package-import__object-list-content bz-color-border--neutral-300 bz-space--stack-m"
        *ngIf="objListOpen == true && data.objList && data.objList.length">
        <ul class="bmc-package-import__list">
            <li *ngFor="let object of data.objList">- {{object}}</li>
        </ul>
    </div>
    <div>
        <div class="bz-space--stack-m">
            <span>{{ 'DEPLOYMENT.CONFIRM_TEXT' | translate }}</span>
        </div>
        <div
            class="bmc-package-info-bex bz-color-border--neutral-400 bz-color-bg--neutral-200 bz-space--inset-squish-s">
            <bzg-icon [size]="30" [nameIcon]="'bex-file'" class="bz-space--inline-m" [color]="'dark'">
            </bzg-icon>
            <div class="bmc-package-info-bex__info-wrapper">
                <strong>{{ data.fileData.name }}</strong>
                <span class="bz-font-size--body-small">{{ data.fileData.date | showDateFormat: 1 }}</span>
            </div>
        </div>
    </div>
</bzg-modal-content>
<bzg-modal-footer class="bmc-delete-alert__footer">
    <bzg-button-secondary (click)="close()" class="bz-space--inline-m">{{ 'GLOBAL.CANCEL' | translate }}
    </bzg-button-secondary>
    <bzg-button-primary (click)="confirm()">{{ 'DEPLOYMENT.IMPORT_PACKAGE' | translate }}</bzg-button-primary>
</bzg-modal-footer>
